module.exports = __webpack_public_path__ + "static/media/gem.a02ca8d4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/sources/images/works__logo/gem.svg
// module id = 720
// module chunks = 0